// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Translations
import { withTranslation } from "react-i18next";
// Styles
import "components/Accordion/styles/styles.scss";
// Components
import FloatButtons from "components/Input/float_buttons";
import Tooltip from "@components/Tooltip";
import { Input, Button } from "@components/Input";
// Vendor
import { addArtifact } from "vendor/application";
import { findExceedingSegment } from "utils/segmentValidation";

class Responses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      active: false,
      iteration: false,
      responses: [],
      segmentError: {},
    };
  }

  updateArtifacts = (e, i, artifact_type, type) => {
    const { intent, updateIntent } = this.props;

    var res = addArtifact(i, artifact_type, type, intent);

    updateIntent(res);
    this.setState({ responses: res.responses });
  };

  handleLimitsResponses = () => {
    const { limits, intent } = this.props;

    if (!intent.extensions.active) {
      if (limits.responses.total < limits.responses.max) {
        return (
          limits.intents_create.intent_responses_total >=
          limits.intents_create.intent_responses
        );
      }
      return true;
    } else if (intent.responses.length >= 1) return true;
  };

  render() {
    const { type, updateElement, intent, t, isFlow } = this.props;
    return (
      <div className={"accordion__element"}>
        {!isFlow && (
        <div className={"accordion__element_header"}>
          <span>
            {t(`intents.config.accordion.${type}.responses.title`)}{" "}
            <Tooltip
              text={t(`intents.config.accordion.${type}.responses.description`)}
            />
          </span>
        </div>
        )}
        <div className={"accordion__element_content phrases"}>
          {intent.responses.length > 0 &&
            intent.responses.map((el, i) => {
              const segmentIdx = this.state.segmentError[i];
              const hasSegmentError = segmentIdx >= 0;
              return (
                <div className={"accordion__elements"} key={i}>
                  <Input
                    id={`intent-phrases-${i}`}
                    type={isFlow ? "primary" : "secondary"}
                    placeholder={t(
                      `intents.config.accordion.${type}.responses.placeholder`
                    )}
                    multiline
                    value={el}
                    error={hasSegmentError}
                    helper={hasSegmentError ? t(`intents.config.accordion.${type}.responses.segment_too_long`, { segment: segmentIdx + 1 }) : undefined}
                    onChange={(e) => {
                      const errorIdx = findExceedingSegment(e.target.value);
                      this.setState({
                        responses: [...intent.responses],
                        segmentError: { ...this.state.segmentError, [i]: errorIdx },
                      });
                      updateElement(e, "responses", "string_array", i);
                    }}
                  />
                  <FloatButtons
                    type={"responses"}
                    addArtifact={this.updateArtifacts}
                    buttons_toggle_actions={["delete"]}
                    buttons_toggle_artifacts={[
                      "file",
                      "img",
                      "link",
                      "button",
                      "carousel",
                      "bubble",
                      "for",
                      "video"
                    ]}
                    iteration={i}
                    onDelete={() =>{
                      updateElement(null, "responses", "delete", i)
                      this.setState({ responses: [...intent.responses] });
                    }
                    }
                  />
                </div>
              );
            })}
          <Button
            disabled={this.handleLimitsResponses()}
            type={"dashed"}
            onClick={(e) => {
              updateElement(e, "responses", "add");
              this.setState({ responses: [...intent.responses] });
            }}
            text={t(`intents.config.accordion.${type}.responses.button`)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const accordion_phrases = connect(mapStateToProps)(Responses);

export default withTranslation("common")(accordion_phrases);
